import axios, { AxiosInstance, AxiosResponse, AxiosError } from 'axios';
import { store } from '@/store';
import { logoutUser } from '@/store/slices/authSlice';
import toast from 'react-hot-toast';

// Mock data for development
const mockListings = [
  // Lagos Properties
  {
    id: '1',
    title: 'Luxury 3-Bedroom Apartment in Lekki',
    description: 'Beautiful apartment with modern amenities and stunning views of the lagoon',
    price: 450000,
    location: 'Lekki, Lagos',
    propertyType: 'apartment',
    bedrooms: 3,
    bathrooms: 2,
    area: 120,
    amenities: ['Swimming Pool', 'Gym', 'Security', 'Parking', '24/7 Water', 'WiFi'],
    images: [
      'https://images.unsplash.com/photo-1545324418-cc1a3fa10c00?w=800',
      'https://images.unsplash.com/photo-1545324418-cc1a3fa10c01?w=800',
    ],
    landlord: {
      id: '1',
      name: 'John Doe',
      email: 'john@example.com',
      phone: '+2348012345678'
    },
    createdAt: '2024-01-15T10:30:00Z',
    status: 'available'
  },
  {
    id: '2',
    title: 'Modern Studio in Victoria Island',
    description: 'Perfect for young professionals with premium location',
    price: 280000,
    location: 'Victoria Island, Lagos',
    propertyType: 'studio',
    bedrooms: 1,
    bathrooms: 1,
    area: 50,
    amenities: ['Security', 'Parking', 'WiFi', 'Air Conditioning'],
    images: [
      'https://images.unsplash.com/photo-1502672260266-1c1ef2d93688?w=800',
      'https://images.unsplash.com/photo-1502672260266-1c1ef2d93689?w=800',
    ],
    landlord: {
      id: '2',
      name: 'Jane Smith',
      email: 'jane@example.com',
      phone: '+2348098765432'
    },
    createdAt: '2024-01-18T14:20:00Z',
    status: 'available'
  },
  {
    id: '3',
    title: 'Cozy 2-Bedroom Flat in Victoria Island',
    description: 'Perfect for young professionals and small families',
    price: 380000,
    location: 'Victoria Island, Lagos',
    propertyType: 'flat',
    bedrooms: 2,
    bathrooms: 1,
    area: 80,
    amenities: ['Security', 'Parking', '24/7 Water', 'WiFi'],
    images: [
      'https://images.unsplash.com/photo-1522708323590-d24dbb6b0267?w=800',
      'https://images.unsplash.com/photo-1522708323590-d24dbb6b0268?w=800',
    ],
    landlord: {
      id: '3',
      name: 'Mike Johnson',
      email: 'mike@example.com',
      phone: '+2348055555555'
    },
    createdAt: '2024-01-20T09:15:00Z',
    status: 'under contract'
  },
  {
    id: '4',
    title: 'Spacious 4-Bedroom House in Ikeja',
    description: 'Family-friendly house with large backyard and servant quarters',
    price: 750000,
    location: 'Ikeja, Lagos',
    propertyType: 'house',
    bedrooms: 4,
    bathrooms: 3,
    area: 200,
    amenities: ['Backyard', 'Security', 'Parking', 'Servant Quarters', 'Garden'],
    images: [
      'https://images.unsplash.com/photo-1564013799919-ab600027ffc6?w=800',
      'https://images.unsplash.com/photo-1564013799919-ab600027ffc7?w=800',
    ],
    landlord: {
      id: '4',
      name: 'Sarah Wilson',
      email: 'sarah@example.com',
      phone: '+2348077777777'
    },
    createdAt: '2024-01-05T16:45:00Z',
    status: 'available'
  },
  {
    id: '5',
    title: 'Studio Apartment in Surulere',
    description: 'Affordable studio for students and young professionals',
    price: 180000,
    location: 'Surulere, Lagos',
    propertyType: 'studio',
    bedrooms: 1,
    bathrooms: 1,
    area: 45,
    amenities: ['Security', 'Parking', 'WiFi'],
    images: [
      'https://images.unsplash.com/photo-1502672260266-1c1ef2d93688?w=800',
      'https://images.unsplash.com/photo-1502672260266-1c1ef2d93689?w=800',
    ],
    landlord: {
      id: '5',
      name: 'David Brown',
      email: 'david@example.com',
      phone: '+2348088888888'
    },
    createdAt: '2024-01-25T11:20:00Z',
    status: 'rented'
  },
  {
    id: '6',
    title: 'Luxury Penthouse in Ikoyi',
    description: 'Exclusive penthouse with panoramic city views',
    price: 800000,
    location: 'Ikoyi, Lagos',
    propertyType: 'penthouse',
    bedrooms: 3,
    bathrooms: 3,
    area: 180,
    amenities: ['Swimming Pool', 'Gym', 'Security', 'Parking', '24/7 Water', 'WiFi', 'Air Conditioning', 'Furnished'],
    images: [
      'https://images.unsplash.com/photo-1545324418-cc1a3fa10c00?w=800',
      'https://images.unsplash.com/photo-1545324418-cc1a3fa10c01?w=800',
    ],
    landlord: {
      id: '6',
      name: 'Emma Davis',
      email: 'emma@example.com',
      phone: '+2348066666666'
    },
    createdAt: '2024-01-10T12:00:00Z',
    status: 'available'
  },

  // Abuja Properties
  {
    id: '7',
    title: 'Modern 3-Bedroom Apartment in Wuse',
    description: 'Contemporary apartment in the heart of Abuja',
    price: 420000,
    location: 'Wuse, Abuja',
    propertyType: 'apartment',
    bedrooms: 3,
    bathrooms: 2,
    area: 110,
    amenities: ['Security', 'Parking', 'WiFi', 'Air Conditioning', 'Gym'],
    images: [
      'https://images.unsplash.com/photo-1545324418-cc1a3fa10c00?w=800',
      'https://images.unsplash.com/photo-1545324418-cc1a3fa10c01?w=800',
    ],
    landlord: {
      id: '7',
      name: 'Ahmed Hassan',
      email: 'ahmed@example.com',
      phone: '+2348044444444'
    },
    createdAt: '2024-01-12T08:30:00Z',
    status: 'available'
  },
  {
    id: '8',
    title: 'Luxury Villa in Maitama',
    description: 'Exclusive villa in Abuja\'s most prestigious neighborhood',
    price: 780000,
    location: 'Maitama, Abuja',
    propertyType: 'villa',
    bedrooms: 5,
    bathrooms: 4,
    area: 300,
    amenities: ['Swimming Pool', 'Gym', 'Security', 'Parking', 'Garden', 'Servant Quarters', 'WiFi'],
    images: [
      'https://images.unsplash.com/photo-1564013799919-ab600027ffc6?w=800',
      'https://images.unsplash.com/photo-1564013799919-ab600027ffc7?w=800',
    ],
    landlord: {
      id: '8',
      name: 'Fatima Aliyu',
      email: 'fatima@example.com',
      phone: '+2348033333333'
    },
    createdAt: '2024-01-08T15:45:00Z',
    status: 'available'
  },
  {
    id: '9',
    title: 'Cozy Studio in Gwarinpa',
    description: 'Affordable studio perfect for students and young professionals',
    price: 220000,
    location: 'Gwarinpa, Abuja',
    propertyType: 'studio',
    bedrooms: 1,
    bathrooms: 1,
    area: 40,
    amenities: ['Security', 'Parking', 'WiFi'],
    images: [
      'https://images.unsplash.com/photo-1502672260266-1c1ef2d93688?w=800',
      'https://images.unsplash.com/photo-1502672260266-1c1ef2d93689?w=800',
    ],
    landlord: {
      id: '9',
      name: 'Usman Bello',
      email: 'usman@example.com',
      phone: '+2348022222222'
    },
    createdAt: '2024-01-22T10:15:00Z',
    status: 'pending approval'
  },

  // Port Harcourt Properties
  {
    id: '10',
    title: 'Modern 2-Bedroom Flat in GRA',
    description: 'Well-maintained flat in Port Harcourt\'s Government Reserved Area',
    price: 320000,
    location: 'GRA, Port Harcourt',
    propertyType: 'flat',
    bedrooms: 2,
    bathrooms: 2,
    area: 85,
    amenities: ['Security', 'Parking', 'WiFi', 'Air Conditioning'],
    images: [
      'https://images.unsplash.com/photo-1522708323590-d24dbb6b0267?w=800',
      'https://images.unsplash.com/photo-1522708323590-d24dbb6b0268?w=800',
    ],
    landlord: {
      id: '10',
      name: 'Chioma Okonkwo',
      email: 'chioma@example.com',
      phone: '+2348011111111'
    },
    createdAt: '2024-01-14T13:20:00Z',
    status: 'available'
  },
  {
    id: '11',
    title: 'Luxury 4-Bedroom House in Old GRA',
    description: 'Spacious family house with modern amenities',
    price: 680000,
    location: 'Old GRA, Port Harcourt',
    propertyType: 'house',
    bedrooms: 4,
    bathrooms: 3,
    area: 180,
    amenities: ['Security', 'Parking', 'Garden', 'Servant Quarters', 'WiFi'],
    images: [
      'https://images.unsplash.com/photo-1564013799919-ab600027ffc6?w=800',
      'https://images.unsplash.com/photo-1564013799919-ab600027ffc7?w=800',
    ],
    landlord: {
      id: '11',
      name: 'Emeka Nwachukwu',
      email: 'emeka@example.com',
      phone: '+2348000000000'
    },
    createdAt: '2024-01-16T11:30:00Z',
    status: 'under contract'
  },

  // Ibadan Properties
  {
    id: '12',
    title: '3-Bedroom Apartment in Bodija',
    description: 'Comfortable apartment in Ibadan\'s residential area',
    price: 280000,
    location: 'Bodija, Ibadan',
    propertyType: 'apartment',
    bedrooms: 3,
    bathrooms: 2,
    area: 100,
    amenities: ['Security', 'Parking', 'WiFi'],
    images: [
      'https://images.unsplash.com/photo-1545324418-cc1a3fa10c00?w=800',
      'https://images.unsplash.com/photo-1545324418-cc1a3fa10c01?w=800',
    ],
    landlord: {
      id: '12',
      name: 'Adebayo Ogunlesi',
      email: 'adebayo@example.com',
      phone: '+2348099999999'
    },
    createdAt: '2024-01-19T09:00:00Z',
    status: 'available'
  },
  {
    id: '13',
    title: 'Studio Apartment in Agbowo',
    description: 'Affordable studio near University of Ibadan',
    price: 150000,
    location: 'Agbowo, Ibadan',
    propertyType: 'studio',
    bedrooms: 1,
    bathrooms: 1,
    area: 35,
    amenities: ['Security', 'Parking'],
    images: [
      'https://images.unsplash.com/photo-1502672260266-1c1ef2d93688?w=800',
      'https://images.unsplash.com/photo-1502672260266-1c1ef2d93689?w=800',
    ],
    landlord: {
      id: '13',
      name: 'Folake Adebayo',
      email: 'folake@example.com',
      phone: '+2348088888888'
    },
    createdAt: '2024-01-23T14:45:00Z',
    status: 'rented'
  },

  // Kano Properties
  {
    id: '14',
    title: '2-Bedroom Flat in Nasarawa GRA',
    description: 'Well-located flat in Kano\'s Government Reserved Area',
    price: 250000,
    location: 'Nasarawa GRA, Kano',
    propertyType: 'flat',
    bedrooms: 2,
    bathrooms: 1,
    area: 70,
    amenities: ['Security', 'Parking', 'WiFi'],
    images: [
      'https://images.unsplash.com/photo-1522708323590-d24dbb6b0267?w=800',
      'https://images.unsplash.com/photo-1522708323590-d24dbb6b0268?w=800',
    ],
    landlord: {
      id: '14',
      name: 'Hassan Dantata',
      email: 'hassan@example.com',
      phone: '+2348077777777'
    },
    createdAt: '2024-01-17T16:20:00Z',
    status: 'available'
  },
  {
    id: '15',
    title: '3-Bedroom House in Tarauni',
    description: 'Family house in a quiet neighborhood',
    price: 380000,
    location: 'Tarauni, Kano',
    propertyType: 'house',
    bedrooms: 3,
    bathrooms: 2,
    area: 120,
    amenities: ['Security', 'Parking', 'Garden'],
    images: [
      'https://images.unsplash.com/photo-1564013799919-ab600027ffc6?w=800',
      'https://images.unsplash.com/photo-1564013799919-ab600027ffc7?w=800',
    ],
    landlord: {
      id: '15',
      name: 'Aisha Yusuf',
      email: 'aisha@example.com',
      phone: '+2348066666666'
    },
    createdAt: '2024-01-21T12:10:00Z',
    status: 'pending approval'
  }
];

const mockUsers = [
  {
    id: '1',
    name: 'John Doe',
    email: 'john@example.com',
    role: 'landlord',
    phone: '+2348012345678',
    avatar: 'https://images.unsplash.com/photo-1472099645785-5658abf4ff4e?w=150'
  },
  {
    id: '2',
    name: 'Jane Smith',
    email: 'jane@example.com',
    role: 'landlord',
    phone: '+2348098765432',
    avatar: 'https://images.unsplash.com/photo-1494790108755-2616b612b786?w=150'
  }
];

// API Configuration
const API_BASE_URL = import.meta.env.VITE_API_URL || 'https://villashunters-com.onrender.com';

// Create axios instance
const api: AxiosInstance = axios.create({
  baseURL: API_BASE_URL,
  timeout: 10000,
  headers: {
    'Content-Type': 'application/json',
  },
});

// Request interceptor to add auth token
api.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('token');
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// Response interceptor to handle auth errors
api.interceptors.response.use(
  (response: AxiosResponse) => {
    return response;
  },
  (error: AxiosError) => {
    const status = error.response?.status;
    if (status === 401) {
      // Token expired or invalid
      store.dispatch(logoutUser());
      toast.error('Session expired. Please login again.');
    } else if (status === 403) {
      toast.error('Access denied. You do not have permission for this action.');
    } else if (status && status >= 500) {
      toast.error('Server error. Please try again later.');
    }
    return Promise.reject(error);
  }
);

// API Response types
export interface ApiResponse<T = any> {
  success: boolean;
  data: T;
  message?: string;
  errors?: Record<string, string[]>;
}

export interface PaginatedResponse<T> extends ApiResponse<T[]> {
  pagination: {
    current_page: number;
    last_page: number;
    per_page: number;
    total: number;
  };
}

// Mock API functions
const delay = (ms: number) => new Promise(resolve => setTimeout(resolve, ms));

// Auth API
export const authAPI = {
  login: async (credentials: { email: string; password: string }): Promise<ApiResponse<{ user: any; token: string }>> => {
    const response = await api.post('/api/auth/login', credentials);
    const { user, session } = response.data;

    if (session?.access_token) {
      localStorage.setItem('token', session.access_token);
      localStorage.setItem('user', JSON.stringify(user));
    }

    return {
      success: true,
      data: { user, token: session?.access_token || '' },
      message: 'Login successful'
    };
  },

  register: async (userData: { name: string; email: string; password: string; role: 'tenant' | 'landlord' }): Promise<ApiResponse<{ user: any; token: string }>> => {
    const response = await api.post('/api/auth/register', userData);
    const { user } = response.data;

    return {
      success: true,
      data: { user, token: '' },
      message: 'Registration successful. Please check your email to verify your account.'
    };
  },

  logout: async (): Promise<void> => {
    localStorage.removeItem('token');
    localStorage.removeItem('user');
  },

  getProfile: async (): Promise<ApiResponse<any>> => {
    const response = await api.get('/api/auth/profile');
    return {
      success: true,
      data: response.data
    };
  },

  updateProfile: async (data: Partial<any>): Promise<ApiResponse<any>> => {
    const response = await api.put('/api/auth/profile', data);
    const updatedUser = response.data;
    localStorage.setItem('user', JSON.stringify(updatedUser));

    return {
      success: true,
      data: updatedUser
    };
  },
};

// Listings API
export const listingsAPI = {
  getAll: async (params?: {
    page?: number;
    limit?: number;
    location?: string;
    minPrice?: number;
    maxPrice?: number;
    amenities?: string[];
    type?: string;
    bedrooms?: number;
    bathrooms?: number;
    radius?: number;
  }): Promise<PaginatedResponse<any>> => {
    await delay(800);
    
    let filteredListings = [...mockListings];
    
    // Apply filters
    if (params?.location) {
      filteredListings = filteredListings.filter(listing => 
        listing.location.toLowerCase().includes(params.location!.toLowerCase())
      );
    }
    
    if (params?.type) {
      filteredListings = filteredListings.filter(listing => 
        listing.propertyType === params.type
      );
    }
    
    if (params?.minPrice) {
      filteredListings = filteredListings.filter(listing => 
        listing.price >= params.minPrice!
      );
    }
    
    if (params?.maxPrice) {
      filteredListings = filteredListings.filter(listing => 
        listing.price <= params.maxPrice!
      );
    }
    
    if (params?.bedrooms) {
      filteredListings = filteredListings.filter(listing => 
        listing.bedrooms >= params.bedrooms!
      );
    }
    
    if (params?.bathrooms) {
      filteredListings = filteredListings.filter(listing => 
        listing.bathrooms >= params.bathrooms!
      );
    }
    
    // Pagination
    const page = params?.page || 1;
    const limit = params?.limit || 10;
    const startIndex = (page - 1) * limit;
    const endIndex = startIndex + limit;
    const paginatedListings = filteredListings.slice(startIndex, endIndex);
    
    return {
      success: true,
      data: paginatedListings,
      pagination: {
        current_page: page,
        last_page: Math.ceil(filteredListings.length / limit),
        per_page: limit,
        total: filteredListings.length
      }
    };
  },

  getById: async (id: string): Promise<ApiResponse<any>> => {
    await delay(500);
    
    const listing = mockListings.find(l => l.id === id);
    if (!listing) throw new Error('Listing not found');
    
    return {
      success: true,
      data: listing
    };
  },

  create: async (data: any): Promise<ApiResponse<any>> => {
    await delay(1000);
    
    const newListing = {
      id: Date.now().toString(),
      ...data,
      createdAt: new Date().toISOString(),
      status: 'available'
    };
    
    mockListings.push(newListing);
    
    return {
      success: true,
      data: newListing
    };
  },

  update: async (id: string, data: any): Promise<ApiResponse<any>> => {
    await delay(1000);
    
    const index = mockListings.findIndex(l => l.id === id);
    if (index === -1) throw new Error('Listing not found');
    
    mockListings[index] = { ...mockListings[index], ...data };
    
    return {
      success: true,
      data: mockListings[index]
    };
  },

  delete: async (id: string): Promise<ApiResponse> => {
    await delay(500);
    
    const index = mockListings.findIndex(l => l.id === id);
    if (index === -1) throw new Error('Listing not found');
    
    mockListings.splice(index, 1);
    
    return {
      success: true,
      data: null,
      message: 'Listing deleted successfully'
    };
  },

  getMyListings: async (): Promise<ApiResponse<any[]>> => {
    await delay(500);
    
    // Return listings for the current user (mock)
    return {
      success: true,
      data: mockListings.slice(0, 3) // Return first 3 as user's listings
    };
  },
};

// Payments API
export const paymentsAPI = {
  createPayment: async (data: {
    listingId: string;
    amount: number;
    type: 'rent' | 'securityDeposit';
    paymentMethod: string;
  }): Promise<ApiResponse<any>> => {
    await delay(2000);
    
    const payment = {
      id: Date.now().toString(),
      ...data,
      status: 'completed',
      reference: `PAY-${Date.now()}`,
      createdAt: new Date().toISOString()
    };
    
    return {
      success: true,
      data: payment
    };
  },

  getPaymentHistory: async (): Promise<ApiResponse<any[]>> => {
    await delay(500);
    
    return {
      success: true,
      data: [
        {
          id: '1',
          listingId: '1',
          amount: 2500000,
          type: 'rent',
          status: 'completed',
          reference: 'PAY-123456',
          createdAt: '2024-01-15T10:00:00Z'
        }
      ]
    };
  },
};

// User Management API
export const usersAPI = {
  getAll: async (_params?: { page?: number; limit?: number; role?: string }): Promise<PaginatedResponse<any>> => {
    await delay(500);
    
    return {
      success: true,
      data: mockUsers,
      pagination: {
        current_page: 1,
        last_page: 1,
        per_page: 10,
        total: mockUsers.length
      }
    };
  },

  getById: async (id: string): Promise<ApiResponse<any>> => {
    await delay(500);
    
    const user = mockUsers.find(u => u.id === id);
    if (!user) throw new Error('User not found');
    
    return {
      success: true,
      data: user
    };
  },

  update: async (id: string, data: any): Promise<ApiResponse<any>> => {
    await delay(1000);
    
    const index = mockUsers.findIndex(u => u.id === id);
    if (index === -1) throw new Error('User not found');
    
    const updatedUser = { ...mockUsers[index], ...data };
    mockUsers[index] = updatedUser;
    
    return {
      success: true,
      data: updatedUser
    };
  },

  delete: async (id: string): Promise<ApiResponse> => {
    await delay(500);
    
    const index = mockUsers.findIndex(u => u.id === id);
    if (index === -1) throw new Error('User not found');
    
    mockUsers.splice(index, 1);
    
    return {
      success: true,
      data: null,
      message: 'User deleted successfully'
    };
  },

  toggleStatus: async (id: string): Promise<ApiResponse<any>> => {
    await delay(1000);
    
    const index = mockUsers.findIndex(u => u.id === id);
    if (index === -1) throw new Error('User not found');
    
    const updatedUser = { 
      ...mockUsers[index], 
      status: (mockUsers[index] as any).status === 'active' ? 'inactive' : 'active' 
    };
    mockUsers[index] = updatedUser;
    
    return {
      success: true,
      data: updatedUser
    };
  },
};

// Error handler
export const handleApiError = (error: any): string => {
  if (error.response?.data?.message) {
    return error.response.data.message;
  }
  if (error.message) {
    return error.message;
  }
  return 'An unexpected error occurred';
};

export default api; 